import { render, staticRenderFns } from "./planlist.vue?vue&type=template&id=5c234ca5&scoped=true"
import script from "./planlist.vue?vue&type=script&lang=js"
export * from "./planlist.vue?vue&type=script&lang=js"
import style0 from "./planlist.vue?vue&type=style&index=0&id=5c234ca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c234ca5",
  null
  
)

export default component.exports